import React, { useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;

export const InstallAppButton = () => {
  const [prompt, setPrompt] = useState(() => window.__americanFitInstallPrompt || null);
  const [installed, setInstalled] = useState(isStandalone());
  useEffect(() => {
    const onAvail = () => setPrompt(window.__americanFitInstallPrompt);
    const onDone = () => { setPrompt(null); setInstalled(true); };
    window.addEventListener("pwa-install-available", onAvail);
    window.addEventListener("pwa-installed", onDone);
    return () => { window.removeEventListener("pwa-install-available", onAvail); window.removeEventListener("pwa-installed", onDone); };
  }, []);
  if (installed) return null;
  const install = async () => {
    if (!window.location.pathname.startsWith("/gestao")) {
      toast.info("Abrindo a versão instalável do sistema… toque em \"Instalar no celular\" de novo.");
      setTimeout(() => { window.location.href = "/gestao" + window.location.pathname + window.location.search; }, 800);
      return;
    }
    if (prompt) {
      prompt.prompt();
      const r = await prompt.userChoice.catch(() => null);
      if (r?.outcome === "accepted") toast.success("American Fit Gestão instalado!");
      window.__americanFitInstallPrompt = null; setPrompt(null);
      return;
    }
    const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
    toast.info(ios ? "No Safari: toque em Compartilhar → Adicionar à Tela de Início" : "No Chrome: toque no menu (⋮) → Instalar app / Adicionar à tela inicial");
  };
  return (
    <button onClick={install} data-testid="admin-install-app-button"
      className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-white bg-rose-600/20 border border-rose-600/40 hover:bg-rose-600/30 transition-colors mb-2">
      <Smartphone className="w-4 h-4 text-rose-400"/>
      <span>Instalar no celular</span>
    </button>
  );
};
